export const CommunicationTemplatesPaths = {
    templatesFormNew: `new`,
    templatesFormEdit: `:templateId`,
} as const;
